import { NgClass } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmationDialogButton } from '../../models/confirmation-dialog-payload';
import { DialogBaseComponent } from '../dialog-base/dialog-base.component';

@Component({
  selector: 'sl-dialog-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass]
})
export class ConfirmationDialogComponent extends DialogBaseComponent {
  content: string;
  title: string;
  buttons: ConfirmationDialogButton.Ok;

  okBtnName = 'OK';
  okBtnSubtext = '';
  cancelBtnName = 'CANCEL';
  cancelBtnSubtext = '';
  aux1BtnName = '';
  aux1BtnSubtext = '';
  okBtnClass = '';
  cancelBtnClass = '';
  aux1BtnClass = '';
  ConfirmationDialogButton = ConfirmationDialogButton;

  hasOk() {
    return this.buttons & ConfirmationDialogButton.Ok;
  }
  hasOkSubtext() {
    return !String.isNullOrEmpty(this.okBtnSubtext);
  }
  getOkButtonClass() {
    return this.okBtnClass ? this.okBtnClass : 'btn-primary';
  }
  hasCancel() {
    return this.buttons & ConfirmationDialogButton.Cancel;
  }
  hasCancelSubtext() {
    return !String.isNullOrEmpty(this.cancelBtnSubtext);
  }
  getCancelButtonClass() {
    return this.cancelBtnClass ? this.cancelBtnClass : 'btn-outline-secondary';
  }
  hasAux1() {
    return this.buttons & ConfirmationDialogButton.Aux1;
  }
  hasAux1Subtext() {
    return !String.isNullOrEmpty(this.aux1BtnSubtext);
  }
  getAux1ButtonClass() {
    return this.aux1BtnClass ? this.aux1BtnClass : ' btn-outline-secondary';
  }
}
